import { ref, watch, computed } from 'vue'
import { useStore } from 'vuex'

import apiMenu from '@/api/menu'

import { toastFunc } from '@/plugins/toastPlugin'

/** @module KP_06-Template */

/**
 * функцию композиции
 * @param {object} param - параметры для композиции
 * @param {function} param.updateDaysTemplateInfo - callback для обнровления информации связанной с шаблонами дней
 *
 * @returns {object} obj
 */
export default function ({
  menuType,
  updateDaysTemplateInfo = () => {},
  afterSendingDaysTemplate = () => {},
}) {
  const store = useStore()

  const isLoggedIn = computed(() => store.getters['client/isLoggedIn'])
  const profile = computed(() => store.getters['client/profile'])

  const isShowDaysTemplatesWarningForm = ref(false)
  const selectedDaysTemplate = ref(null)
  const selectedDaysTemplate2 = ref(null)

  const daysFilterTemplateId = computed(() => {
    if (isLoggedIn.value) {
      return undefined
    } else {
      return selectedDaysTemplate2.value?.templateId || undefined
    }
  })

  const daysTemplate = ref({
    hide: true,
  })

  const setDaysTemplate = (days = {}) => {
    days.hide = true
    if (days?.templates && days.templates.length > 0) {
      days.hide = false
      days.templates = [
        {
          templateId: null,
          frontName: 'Каждый день',
          frontDescription: '',
          mealNumbersToRemove: [],
        },
        ...days.templates,
      ]
      if (isLoggedIn.value && profile.value.menuCalendarConfig?.filter?.days) {
        const enabledTemplate = days.templates.find(item => item.templateId === profile.value.menuCalendarConfig.filter.days)
        selectedDaysTemplate.value = enabledTemplate
        selectedDaysTemplate2.value = enabledTemplate
      } else if (selectedDaysTemplate.value) {
        const enabledTemplate = days.templates.find(item => item.templateId === selectedDaysTemplate.value.templateId)
        selectedDaysTemplate.value = enabledTemplate
        selectedDaysTemplate2.value = enabledTemplate
      } else {
        const enabledTemplate = days.templates.find(item => item.isEnabled) || days.templates[0]
        selectedDaysTemplate.value = enabledTemplate
        selectedDaysTemplate2.value = enabledTemplate
      }
    }
    daysTemplate.value = days
  }

  const sendingTeplate = ref(false)
  const sendDaysTemplate = async ({ toast } = { toast: true }) => {
    sendingTeplate.value = false
    try {
      // TODO filters/days
      const response = await apiMenu.postFiltersDays({ menuType: menuType.value, templateId: selectedDaysTemplate2.value.templateId || undefined })
      const { success, messages, errorCode } = response.data
      if (success) {
        afterSendingDaysTemplate({
          templateId: selectedDaysTemplate2.value.templateId || undefined,
          needGetMenu: toast,
        })
        if (toast) {
          toastFunc({ group: 'success', title: 'Настройки применены', text: 'Они будут применяться автоматически ко всем следующим заказам' })
        }
      } else {
        if (errorCode) {
          if (messages) {
            messages.forEach((message) => {
              toastFunc({ group: 'error', title: message })
            })
          }
        }
      }
    } catch (error) {
      const {
        data: {
          message = '',
          messages,
        } = {},
      } = error || {}
      if (message) {
        toastFunc({ group: 'error', title: `${message}` })
      }
      if (messages) {
        messages.forEach((message) => {
          toastFunc({ group: 'error', title: message })
        })
      }
    } finally {
      sendingTeplate.value = false
    }
  }

  const confirmDaysTemplate = () => {
    selectedDaysTemplate2.value = selectedDaysTemplate.value
  }

  const cancelDaysTemplate = () => {
    selectedDaysTemplate.value = selectedDaysTemplate2.value
  }

  watch(selectedDaysTemplate, (val, old) => {
    if (val !== old &&
        val !== selectedDaysTemplate2.value
    ) {
      isShowDaysTemplatesWarningForm.value = true
    }
  })

  watch(selectedDaysTemplate2, (val, old) => {
    store.dispatch('templates/setDaysFilterTemplateId', val?.templateId)
    if (val && old && val.templateId !== old.templateId) {
      if (isLoggedIn.value) {
        sendDaysTemplate()
      }
      updateDaysTemplateInfo(val.templateId || undefined)
    }
  })

  return {
    // data
    selectedDaysTemplate,
    selectedDaysTemplate2,
    isShowDaysTemplatesWarningForm,
    daysTemplate,
    // computed
    daysFilterTemplateId,
    // methods
    setDaysTemplate,
    sendDaysTemplate,
    confirmDaysTemplate,
    cancelDaysTemplate,
  }
}
